<template>
    <v-container>
        <v-row class="center header-row">
            <h2>1. {{ isBusiness ? 'Select Open/Closing Time' : 'Select Availability' }}</h2>
        </v-row>
        <v-container>
            <v-row class="center">
                <v-col style="padding: 0px;" sm="4" cols="5">
                    <vue-timepicker ref="opens" close-on-complete v-model="opens" input-class="time-picker-input" :placeholder="isBusiness ? 'Opens' : 'Start'"
                        class="picker-container right-dropdown" :minute-interval="30" format="hh:mm A" @change="setCloseFloor">
                        <template v-slot:clearButton>
                            <div><v-icon>fas fa-times</v-icon></div>
                        </template>
                    </vue-timepicker>
                </v-col>
                <v-col cols="2" style="padding: 0px;">
                    <span style="font-size: 30pt;">-</span>
                </v-col>
                <v-col style="padding: 0px;" sm="4" cols="5">
                    <vue-timepicker :hour-range="closeRange" ref="closes" close-on-complete v-model="closes" :minute-interval="30" input-class="time-picker-input" 
                        :placeholder="isBusiness ? 'Closes' : 'End'" class="picker-container left-dropdown" format="hh:mm A">
                        <template v-slot:clearButton>
                            <v-icon>fas fa-times</v-icon>
                        </template>
                    </vue-timepicker>
                </v-col>
            </v-row>
        </v-container>
        <v-row v-if="opens && closes" class="center header-row">
            <h2>2. Select Days</h2>
        </v-row>
        <v-item-group multiple v-model="selectedDays" active-class="active-card">
            <v-container>
                <v-row v-if="opens && closes">
                    <v-col cols="3">
                        <v-item v-slot="{ toggle }" :value="1">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Mon.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                    <v-col cols="3">
                        <v-item v-slot="{ toggle }" :value="2">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Tue.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                    <v-col cols="3">
                        <v-item v-slot="{ toggle }" :value="3">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Wed.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                    <v-col cols="3">
                        <v-item v-slot="{ toggle }" :value="4">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Thu.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                    <v-col cols="4">
                        <v-item v-slot="{ toggle }" :value="5">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Fri.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                    <v-col cols="4">
                        <v-item v-slot="{ toggle }" :value="6">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Sat.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                    <v-col cols="4">
                        <v-item v-slot="{ toggle }" :value="7">
                            <v-card class="weekday-card" @click="toggle" height="75">
                                <span>Sun.</span>
                            </v-card>
                        </v-item>
                    </v-col>
                </v-row>
                <v-row class="center" v-else>
                    <span>(Select {{ isBusiness ? 'Open/Closing Time' : 'Availability TImes'}} Before Selecting Days)</span>
                </v-row>
            </v-container>
        </v-item-group>
        <v-row class="center ma-2" v-if="selectedDays.length || hasChanges">
            <site-button
                :colNum="8"
                btnType="text"
                text="Submit"
                label="Submit Changes"
                @click-event="saveChanges"
                colorClasses="secondary-icon"
                iconColor="primary-icon"
                iconString="fa-solid fa-circle-check"
            ></site-button>
        </v-row>
        <hr />
        <v-row v-for="(day, index) of initHours" :key="index" class="center ma-2">
            <v-col cols="10" sm="6" v-if="day.opens && day.closes">
                <span>
                    {{ weekdayLabels[day.weekDay - weekDayMin] }} <br v-if="isSmall" />
                    {{ day.opens }} - {{ day.closes }}
                    <v-tooltip top class="secondary-tooltip" v-if="!isSmall">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs" @click="removeHours(day.weekDay)" class="secondary-icon" style="margin-right: 0.5em;" icon>
                                <v-icon>fas fa-minus</v-icon>
                            </v-btn>
                        </template>
                        <span>Delete {{ weekdayLabels[day.weekDay - weekDayMin] }} Hours</span>
                    </v-tooltip>
                </span>
            </v-col>
            <v-col cols="2" v-if="day.opens && day.closes && isSmall">
                <v-tooltip top class="secondary-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-on="on" v-bind="attrs" @click="removeHours(day.weekDay)" class="secondary-icon" style="margin-right: 0.5em;" icon>
                            <v-icon>fas fa-minus</v-icon>
                        </v-btn>
                    </template>
                    <span>Delete {{ weekdayLabels[day.weekDay - weekDayMin] }} Hours</span>
                </v-tooltip>
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="scss">

.header-row {
    margin-top: 0.5em !important;
}

.v-text-field__details {
    display: none;
}

</style>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import SiteButton from '../../common/SiteButton';
import WeekDayEnums from '../../../assets/Enums/WeekdayEnum';

export default {
    name: 'business-hours',
    components: {
        'site-button': SiteButton,
        VueTimepicker,
    },
    model: {
        prop: 'businessHours',
        event: 'change',
    },
    props: {
        businessHours: Array,
        variant: {
            type: String,
            default: 'BUSINESS'
        }
    },
    data: () => ({
        opens: '',
        closes: '',
        hasChanges: false,
        initHours: [],
        selectedDays: [],
        closeRange: [],
        hoursRange: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
            11, 12, 13, 14, 15, 16, 17, 18, 
            19, 20, 21, 22, 23, 24
        ]
    }),
    created() {
        this.initHours = this.businessHours;
    },
    methods: {
        setCloseFloor(time) {
            const floor = parseInt(time.data.HH)
            console.log('floor ' + floor)
            this.closeRange = this.hoursRange.filter(h => floor < h);
        },
        resetValidation() {},
        removeHours(weekDay) {
            this.hasChanges = true;
            this.initHours[weekDay - this.weekDayMin].opens = '';
            this.initHours[weekDay - this.weekDayMin].closes = '';
        },
        saveChanges() {
            for(const day of this.selectedDays) {
                console.log('day ' + (day - this.weekDayMin));
                console.log('hours day ' + this.initHours[day - this.weekDayMin].weekDay);

                this.initHours[day - this.weekDayMin].opens = this.opens;
                this.initHours[day - this.weekDayMin].closes = this.closes;
            }
            this.opens = '';
            this.closes = '';
            this.hasChanges = false;
            document.querySelector('.opens-dropdown .clear-btn').click();
            document.querySelector('.closes-dropdown .clear-btn').click();
            this.$emit('update-hours', this.initHours);
        },
        handleChange() {

        }
    },
    computed: {
        weekdayLabels() {
            return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
        },
        weekDayMin() {
            return WeekDayEnums.MON;
        },
        isBusiness() {
            return this.variant == 'BUSINESS';
        },
        isSmall() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true
                case 'sm':
                    return true
                default:
                    return false
            }
        }
    }
}
</script>
